<template lang="pug">
v-row(no-gutters)
  v-col.pa-10(cols="3")
    .sticky.top-24.white
      .text-md.font-semibold.neutral200.px-4.py-2.rounded-lg {{ $t('appointment_settings') }}
      ul.mt-3.settings-side-menu
        template(v-for="menu in menus")
          router-link(:to="menu.target" v-slot="{ href, route, navigate, isActive, isExactActive }")
            li.py-2.px-4(@click="navigate" :class="isActive ? 'active' : ''") {{ menu.title }}

  v-col.neutral200(cols="9")
    v-container.pa-8
      .d-flex.align-center.mb-6
        v-btn.mr-4(icon small)
          v-icon(color="primary" @click="back") mdi-arrow-left
        .text-2xl.font-semibold {{ $t('appointment_settings') }}

      v-card.rounded-lg.pa-4.mb-4#payment(outlined)
        v-col(cols="8")
          .h8.mb-6 {{ $t('payment_settings') }}
          .text-sm.font-medium.mb-4 {{ $t('automatic_payments') }}
          template(v-for="(method, index) in paymentMethods")
            .d-flex.align-center
              .flex-grow-1 {{ method }}
              .mt-3
                y-switch
            v-divider(v-if="index !== paymentMethods.length - 1")
          v-divider.mt-10.mb-4
          .text-sm.font-medium.mb-4 {{ $t('manual_payments') }}
          template(v-for="method in manualMethods")
            v-card.px-4.py-3.d-flex.align-center.rounded-lg.mb-2(outlined)
              .flex-grow-1 
                .h9 {{ method.title }}
                .text-sm {{ method.detail }}
              div
                yc-checkbox
        
      v-card.rounded-lg.pa-6.mb-4#add-website(outlined)
        sharing-embed

      v-card.rounded-lg.pa-6.mb-4#qr-code(outlined)
        sharing-qr-code

      v-card.rounded-lg.pa-6.mb-4#seo(outlined)
        sharing-seo
      
      v-card.rounded-lg.pa-6.mb-4#whatsapp(outlined)
        v-col(cols="8")
          .h8 {{ $t('whatsapp_button') }}
          .text-sm {{ $t('whatsapp_button_description') }}
          .d-flex.align-center
            .flex-grow-1 {{ $t('enable_whatsapp_button') }}
            .mt-3
              y-switch

      .pb-16

    v-footer.white(padless fixed)
      .d-flex.flex-column.grow
        v-divider
        .d-flex.justify-end.align-center.py-4.px-8
          y-button(label="Cancel" size="sm" color="primary" underline @click="back")
          y-button(label="Save" size="sm" color="primary" @click="save")

</template>

<script>
import SharingEmbed from '@/components/clinic/manage/SharingEmbed.vue'
import SharingQrCode from '@/components/clinic/manage/SharingQrCode.vue'
import SharingSeo from '@/components/clinic/manage/SharingSeo.vue' 

export default {
  components: { SharingEmbed, SharingQrCode, SharingSeo },
  data: () => ({
    menus: [
      { target: '#payment', title: 'Payment' },
      { target: '#add-website', title: 'Add to website' },
      { target: '#qr-code', title: ' QR Code' },
      { target: '#seo', title: 'SEO' },
      { target: '#whatsapp', title: 'WhatsApp button' },
    ],
    paymentMethods: [
      'Credit card (Visa/Mastercard etc.)',
      'Internet banking',
      'E-Wallet (Grab)',
    ],
    manualMethods: [
      { title: 'Bank transfer', detail: 'Allow patients to pay online via major banks' },
      { title: 'Pay at counter', detail: 'Allow patients to pay manually at counter' },
      { title: 'QR pay', detail: 'Allow patients to pay via QR scan' }
    ]
  }),
  methods: {
    scrollTo (target) {
      this.$vuetify.goTo(target)
    },
    back () {
      this.$router.push('/admin/clinic/settings')
    },
    save () {}
  }
}
</script>
